import React, { useState } from "react";
import AiImg from "../assets/images/ai-img.png";

interface AiAssistantModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const suggestions = [
  "Book A Flight",
  "Plan A Trip",
  "Find My Flight",
  "Find Nearby Places",
];

const AiAssistantModal: React.FC<AiAssistantModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [query, setQuery] = useState("");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4">
      <div className="relative w-full max-w-sm h-[85vh] bg-[#1a1a1a] rounded-3xl flex flex-col overflow-hidden shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between px-5 pt-5 pb-2">
          <button
            type="button"
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/10 hover:bg-white/20 transition-colors"
          >
            <svg className="w-4 h-4 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <button
            type="button"
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/10 hover:bg-white/20 transition-colors"
          >
            <svg className="w-4 h-4 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>
        </div>

        {/* Center Glow Image */}
        <div className="flex-1 flex items-center justify-center">
          <img
            src={AiImg}
            alt="StandBy AI"
            className="w-52 h-52 object-contain"
          />
        </div>

        {/* Bottom Section */}
        <div className="px-4 pb-5">
          {/* Suggestion Chips */}
          <div className="flex gap-2 mb-4 overflow-x-auto no-scrollbar pb-1">
            {suggestions.map((label) => (
              <button
                key={label}
                type="button"
                onClick={() => setQuery(label)}
                className="flex items-center gap-1.5 px-3 py-2 bg-white/10 hover:bg-white/15 rounded-full text-xs text-white/80 whitespace-nowrap transition-colors"
              >
                <svg className="w-3 h-3 text-[#FBBF24] flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l2.4 7.2H22l-6 4.8 2.4 7.2L12 16.4l-6.4 4.8 2.4-7.2-6-4.8h7.6z" />
                </svg>
                {label}
              </button>
            ))}
          </div>

          {/* Input Field */}
          <div className="flex items-center gap-2">
            <div className="flex-1 relative">
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Ask StandBy AI"
                className="w-full bg-white/10 text-white placeholder-white/40 text-sm rounded-full px-4 py-3 pr-4 focus:outline-none focus:ring-2 focus:ring-[#FBBF24]/50 transition-all"
              />
            </div>
            <button
              type="button"
              className="w-11 h-11 flex items-center justify-center rounded-full bg-[#FBBF24] hover:bg-[#F59E0B] transition-colors flex-shrink-0"
            >
              <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1 1.93c-3.94-.49-7-3.85-7-7.93h2c0 3.31 2.69 6 6 6s6-2.69 6-6h2c0 4.08-3.06 7.44-7 7.93V19h4v2H8v-2h4v-3.07z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiAssistantModal;
